var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('complaint-dialog'),_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('complaints-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }